import { formatAmount } from '../billing/calc.js';
import { formatInZone } from '../time/index.js';

/**
 * Report model (server services/reports): { title, columns: [{ key, label, type, total?, print? }],
 * rows, totals, summary: [{ label, value, type }], notes?, truncated?, chart? }.
 * Column types: text | money (paise) | int | pct | date (YYYY-MM-DD) | datetime | rating.
 */
export function reportCellText(col, v, tz = 'Asia/Kolkata') {
  if (v == null || v === '') return '';
  if (v === 'Total') return 'Total';
  switch (col.type) {
    case 'money':
      return formatAmount(v);
    case 'pct':
      return `${v}%`;
    case 'date':
      return formatInZone(new Date(`${v}T12:00:00Z`), 'UTC', 'dd LLL yyyy');
    case 'datetime':
      return formatInZone(v, tz, 'dd LLL yyyy, hh:mm a');
    case 'rating':
      return `${v}/5`;
    case 'int':
      return Number(v).toLocaleString('en-IN');
    default:
      return String(v);
  }
}

export const reportSummaryText = (s, tz) =>
  s.type === 'text' ? String(s.value) : reportCellText({ type: s.type }, s.value, tz);
